/* @HEADER
 * @version 1.1.289 | 2026-10-18
 * @purpose Bounded registry of stable automation-facing DOM hooks for the hint search shows when «Подсветить на доске» finds a card in another space.
 * @sidecar search-elsewhere.testids.ts.header.md
 * @layer app | @hex _none_ | @ctx search
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-7685

export const SEARCH_ELSEWHERE_TESTIDS = {
  /** The hint «Карточка в пространстве «X»» (role=status). */
  notice: 'search-elsewhere-notice',
  /** «Перейти к карточке в пространство «X»» — opens that space and highlights the card. */
  go: 'search-elsewhere-go',
  /** Closes the hint without going anywhere. */
  close: 'search-elsewhere-close',
} as const;
